module.exports = __webpack_public_path__ + "310b3469d21512f13cfb816d00f0cd79.png";